import gql from 'graphql-tag';

export const GET_PERFORMANCE_OVERVIEW = gql`
  query PerformanceOverview($params: ReportInput!) {
    merchantTransactionTotals(params: $params) {
      merchantName
      merchantId
      cashbackPercentage
      numberOfTransactions
      cashbackAmount
      totalTransactionAmount
      avgAov
      roas
      startDate
      endDate
    }
  }
`;

export const GET_PERFORMANCE_OVERVIEW_BY_SEGMENT = gql`
  query PerformanceOverviewBySegment($params: ReportInput!) {
    merchantTransactionTotalsBySegment(params: $params) {
      merchantName
      merchantId
      segmentId
      numberOfTransactions
      cashbackAmount
      totalTransactionAmount
      avgAov
      roas
      startDate
      endDate
    }
  }
`;

export default {
  GET_PERFORMANCE_OVERVIEW,
  GET_PERFORMANCE_OVERVIEW_BY_SEGMENT,
};
